import { AppConfig } from "../../contexts/AppConfigContext";
import { Rules } from "./Rules.domain";

export class RulesModel {
  private apiBase: string;

  constructor(config: AppConfig) {
    this.apiBase = `${config.assignementsAPI}/v1/api/activity-rules`;
  }

  private getAuthHeaders(token: string, headers: HeadersInit = {}): HeadersInit {
    if (!token) {
      throw new Error("No token available. User must be authenticated.");
    }

    return {
      ...headers,
      Authorization: `Bearer ${token}`,
    };
  }

  private async fetchWithAuth<T>(
    url: string,
    token: string,
    options: RequestInit = {},
  ): Promise<{ status: number; data: T | null }> {
    const headers = this.getAuthHeaders(token, options.headers || {});

    const response = await fetch(url, { ...options, headers });
    let data: T | null = null;

    try {
      data = await response.json();
    } catch (err) {
      // Ignore JSON errors (empty response bodies).
    }

    return { status: response.status, data };
  }

  async getRules(token: string): Promise<{ status: number; data: Rules | null }> {
    return this.fetchWithAuth<Rules>(`${this.apiBase}/1`, token);
  }
}
